import { useEffect, useState } from 'react'
import { ABOUT_RETINAR_CONTENT } from './data'
import {
  Overlay,
  Modal,
  Dialog,
  Header,
  HeaderText,
  Title,
  Subtitle,
  CloseButton,
  CloseIcon,
  Tabs,
  Tab,
  Body,
  LabelPanel,
  LabelImage,
  InfoPanel,
  HeroCard,
  HeroLogo,
  HeroText,
  HeroName,
  HeroDescription,
  SectionsGrid,
  SectionCard,
  SectionTitle,
  FieldList,
  FieldRow,
  FieldLabel,
  FieldValue,
  FieldLink,
  WarningCard,
  WarningTitle,
  WarningList,
  WarningItem
} from './styles'

const TABS = [
  ABOUT_RETINAR_CONTENT.tabs.label,
  ABOUT_RETINAR_CONTENT.tabs.additionalInformation
]

export function AboutRetinar ({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState(ABOUT_RETINAR_CONTENT.tabs.label)

  useEffect(() => {
    if (!isOpen) return

    const previousOverflow = document.body.style.overflow
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', handleEscape)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  useEffect(() => {
    if (isOpen) {
      setActiveTab(ABOUT_RETINAR_CONTENT.tabs.label)
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <>
      <Overlay onClick={onClose} aria-hidden='true' />
      <Modal role='presentation'>
        <Dialog role='dialog' aria-modal='true' aria-labelledby='about-retinar-title'>
          <Header>
            <HeaderText>
              <Title id='about-retinar-title'>{ABOUT_RETINAR_CONTENT.title}</Title>
              <Subtitle>Rotulado electrónico del producto</Subtitle>
            </HeaderText>
            <CloseButton type='button' onClick={onClose} aria-label='Cerrar acerca de Retinar'>
              <CloseIcon aria-hidden='true' />
            </CloseButton>
          </Header>

          <Tabs role='tablist' aria-label='Pestañas de Acerca de Retinar'>
            {TABS.map(tab => (
              <Tab
                key={tab}
                type='button'
                role='tab'
                aria-selected={activeTab === tab}
                $active={activeTab === tab}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </Tab>
            ))}
          </Tabs>

          <Body>
            {activeTab === ABOUT_RETINAR_CONTENT.tabs.label
              ? (
                <LabelPanel>
                  <LabelImage
                    src={ABOUT_RETINAR_CONTENT.image.src}
                    alt={ABOUT_RETINAR_CONTENT.image.alt}
                  />
                </LabelPanel>
                )
              : (
                <InfoPanel>
                  <HeroCard>
                    <HeroLogo
                      src={ABOUT_RETINAR_CONTENT.hero.logoSrc}
                      alt={ABOUT_RETINAR_CONTENT.hero.logoAlt}
                    />
                    <HeroText>
                      <HeroName>{ABOUT_RETINAR_CONTENT.hero.name}</HeroName>
                      <HeroDescription>{ABOUT_RETINAR_CONTENT.hero.description}</HeroDescription>
                    </HeroText>
                  </HeroCard>

                  <SectionsGrid>
                    {ABOUT_RETINAR_CONTENT.sections.map(section => (
                      <SectionCard key={section.title}>
                        <SectionTitle>{section.title}</SectionTitle>
                        <FieldList>
                          {section.items.map(item => (
                            <FieldRow key={item.label}>
                              <FieldLabel>{item.label}</FieldLabel>
                              <FieldValue>
                                {item.href
                                  ? (
                                    <FieldLink href={item.href} target='_blank' rel='noreferrer'>
                                      {item.value}
                                    </FieldLink>
                                    )
                                  : (
                                      item.value
                                    )}
                              </FieldValue>
                            </FieldRow>
                          ))}
                        </FieldList>
                      </SectionCard>
                    ))}
                  </SectionsGrid>

                  <WarningCard>
                    <WarningTitle>{ABOUT_RETINAR_CONTENT.warnings.title}</WarningTitle>
                    <WarningList>
                      {ABOUT_RETINAR_CONTENT.warnings.items.map(item => (
                        <WarningItem key={item}>{item}</WarningItem>
                      ))}
                    </WarningList>
                  </WarningCard>
                </InfoPanel>
                )}
          </Body>
        </Dialog>
      </Modal>
    </>
  )
}

export default AboutRetinar
